import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { MasterScopeItem } from '../../models/master-scope/master-scope-item';

@Injectable({
  providedIn: 'root'
})
export class MasterScopeService {
  private baseUrl: string;
  private headers = new HttpHeaders();

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL') baseUrl: string,
    private toastr: ToastrService
  ) {
    this.baseUrl = baseUrl;
  }

  public getSellersByMaster(id_usuario: number): Observable<MasterScopeItem[]> {
    const data = {
      guidclientenapis: localStorage.getItem('guidclientenapis'),
      id_usuario
    };

    return this.http.post<MasterScopeItem[]>(
      this.baseUrl + 'api/MasterScope/GetSellersByMaster', data, { headers: this.headers }
    ).pipe(
      catchError(() => {
        this.toastr.error('', 'Houve um erro, contate o suporte...');
        return of([]);
      })
    );
  }

  public searchSellers(q: string): Observable<MasterScopeItem[]> {
    const data = {
      guidclientenapis: localStorage.getItem('guidclientenapis'),
      q,
      page: 1,
      pageSize: 20
    };

    return this.http.post<MasterScopeItem[]>(
      this.baseUrl + 'api/MasterScope/SearchSellers', data, { headers: this.headers }
    ).pipe(
      catchError(() => {
        this.toastr.error('', 'Houve um erro, contate o suporte...');
        return of([]);
      })
    );
  }

  public syncSellers(id_usuario: number, sellerIds: number[]): Observable<boolean> {
    const data = {
      guidclientenapis: localStorage.getItem('guidclientenapis'),
      id_usuario,
      sellerIds
    };

    return this.http.post<boolean>(
      this.baseUrl + 'api/MasterScope/SyncSellers', data, { headers: this.headers }
    ).pipe(
      catchError(() => {
        this.toastr.error('', 'Houve um erro, contate o suporte...');
        return of(false);
      })
    );
  }
}
